import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import SuperAdminNavbar from "./NavBars/SuperAdminNavbar";
import ClinetServiceNavbar from "./NavBars/ClinetServiceNavbar";
import SetCastNavBar from './NavBars/SetCastNavBar';
import Navbar from "./NavBars/Navbar";
import TalnetNavBar from './NavBars/TalnetNavBar';

const AppNavbar = () => {
  const { userRole } = useAuth();
  
  switch (userRole) {
    case 'superadmin':
      return <SuperAdminNavbar />;
    case 'clientService':
      return <ClinetServiceNavbar />;
    case 'setCastEditor':
      return <SetCastNavBar />;
    case 'planning':
      return <ClinetServiceNavbar />;
    case 'talent': 
      return <TalnetNavBar />;
    default:
      return <Navbar />;
  }
};

export default AppNavbar;